module.exports = __webpack_public_path__ + "static/media/manualPay.cf9e1801.svg";